module.exports = __webpack_public_path__ + "media/images/v2/icon1-b7157184c554a7f4bc265d406b8ccc64.png";